import React from 'react';
import Dashboard from '../components/layout/Dashboard';
import { withAuthRequired } from '../containers/providers/AuthProvider';


const DashboardPage  = () => (
    <Dashboard />
);

export default withAuthRequired(DashboardPage);
